/**
 * Extracts numeric value from a rate string by removing percent symbols and other non-numeric characters.
 *
 * @param rate - Rate string (e.g., "50%", "50٪", "50.5%")
 * @returns Numeric value as string (e.g., "50", "50.5")
 */
export const extractNumericRate = rate => {
  return rate.replace(/[^\d.]/g, '').trim();
};
//# sourceMappingURL=extractNumericRate.js.map